import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { FORM_OBJECT_TYPE } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { ResolvedUserCell } from 'framework-data-table/contentRenderers/properties/ResolvedUserCell';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CreatedByCell({
  crmObject,
  propertyName,
  propertyDefinition
}) {
  const id = getPropertyValue(crmObject, propertyName);
  const createdDate = getPropertyValue(crmObject, PROPERTIES.CREATED_AT);
  const createdByNotAvailable = I18n.moment(Number(createdDate)).isBefore(I18n.moment('20230530', 'YYYYMMDD'));
  if (!id && createdByNotAvailable) {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      gap: 4,
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !createdByNotAvailable,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.frameworkTable.columns.createdByUserId.tooltip"
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      }), /*#__PURE__*/_jsx(ResolvedUserCell, {
        id: id,
        objectTypeId: FORM_OBJECT_TYPE,
        type: 'USER'
      })]
    });
  }
  return /*#__PURE__*/_jsx(ResolvedUserCell, {
    id: id,
    objectTypeId: FORM_OBJECT_TYPE,
    type: 'USER',
    propertyDefinition: propertyDefinition
  });
}
export const createdByCell = {
  width: 135,
  renderCell: props => /*#__PURE__*/_jsx(CreatedByCell, Object.assign({}, props))
};